var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-height":"100%"}},[_c('br'),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.product_history,"item-key":"name","footer-props":{
    'items-per-page-options': [4],
    prevIcon: 'mdi-minus',
    nextIcon: 'mdi-plus'
    }},on:{"click:row":_vm.handleClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }